import CatalogPage from "@/components/feature/CatalogPage";

export default function TvPage() {
  return (
    <CatalogPage
      type="tv"
      heading="电视剧频道"
      intro="免费播放片大片电视剧频道收录国产、欧美、日韩等地区的热门新剧与经典剧集。支持按类型、地区与年份筛选，并按最新、评分或热度排序，追剧更省心。"
      breadcrumb="电视剧"
      showRegion
      metaTitle="电视剧频道 - 免费播放片大片 热门剧集分类浏览"
      metaDescription="免费播放片大片电视剧频道收录国产、欧美、日韩热门剧集，支持类型、地区与年份筛选，并按最新、评分、热度排序浏览。"
      metaKeywords="电视剧频道,国产剧,美剧,日韩剧,热门剧集,电视剧资源"
    />
  );
}